import PropTypes from "prop-types";
import { AddMore } from "../../../../svg/add-more";
import "./add-info-component.scss";

function AddInfoComponent(props) {
  return (
    <div className="add-info-wrapper" onClick={props.onClick}>
      <AddMore />
      <div className="add-info-title">{props.title}</div>
    </div>
  );
}

AddInfoComponent.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default AddInfoComponent;
